import { ProgramOverviewItemType } from '.';
import { LOAD, LOAD_FAILURE, LOAD_SUCCESS, SET_LOADING_STATE } from './programOverview.actionTypes';

export const actionCreators = {
	doLoadOverview: (programId: string) => ({
		type: LOAD,
		programId,
	}),
	doLoadOverviewSuccess: (programOverviewInformation: ProgramOverviewItemType[]) => ({
		type: LOAD_SUCCESS,
		programOverviewInformation,
	}),
	doLoadOverviewFailure: (error: Error) => ({
		type: LOAD_FAILURE,
		error,
	}),
	doSetLoadingState: (isLoading: boolean) => ({
		type: SET_LOADING_STATE,
		isLoading,
	}),
};

export type ProgramOverviewActionType =
	| ReturnType<typeof actionCreators.doLoadOverview>
	| ReturnType<typeof actionCreators.doSetLoadingState>
	| ReturnType<typeof actionCreators.doLoadOverviewSuccess>
	| ReturnType<typeof actionCreators.doLoadOverviewFailure>;
